import React from 'react';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import ClassNames from 'classnames';
import { BEM_BLOCK_NAME } from '../constants';

type PropTypes = {
    campaignName: string;
};

const useStyles = makeStyles(({ palette, spacing }) => ({
    root: {
        justifyContent: 'center',
        border: `solid 1px ${palette.border.primary}`,
        borderRadius: '24px',
        display: 'flex',
        padding: [[spacing(2), spacing(4)]],
    },
    orSeprator: {
        color: palette.grey[400],
    },
}));

function SantaRosaEnglishGivingInstructions({ campaignName }: PropTypes) {
    const classes = useStyles();

    const rootClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_instructions_santa_rosa`,
        classes.root,
    );

    return (
        <div className={rootClassNames}>
            <div className={`${BEM_BLOCK_NAME}--giving_instructions_santa_rosa_inner`}>
                <strong>Interbank/Direct Transfer</strong>
                <div>BPI CA 8921 0024 76</div>
                <p>
                    Email deposit slip to
                    {'\u00a0'}
                    <a href="admin@saddleback.com.ph">admin@saddleback.com.ph</a>
                    {'\u00a0'}
                    {`and note '${campaignName}'`}
                </p>
                <p className={ClassNames(`${BEM_BLOCK_NAME}--giving_instructions_santa_rosa_or_separator`, classes.orSeprator)}>- OR -</p>
                <div><strong>Debit Card/Credit Card</strong></div>
                <div><a href="https://srgive.online/">https://srgive.online/</a></div>
            </div>
        </div>
    );
}

export default SantaRosaEnglishGivingInstructions;
